import type { TypeInputState } from '~/types/common.types';

/**
 * 전체 옵션
 */
export const OPTION_ALL = { value: '', text: '전체' } as const;

/**
 * 입력/선택 필드 상태
 */
export const DEFAULT_INPUT_STATUS = {
  status: 'default',
  message: '',
} as TypeInputState;

export const ERROR_REQUIRED_INPUT_STATUS = {
  status: 'error',
  message: '필수 입력입니다.',
} as TypeInputState;

export const ERROR_REQUIRED_SELECT_STATUS = {
  status: 'error',
  message: '필수 선택입니다.',
} as TypeInputState;

export const ERROR_INVALID_FORMAT_INPUT_STATUS = {
  status: 'error',
  message: '올바른 형식으로 입력해주세요.',
} as TypeInputState;

export const ERROR_STATUS = {
  status: 'error',
  message: '',
} as TypeInputState;

/**
 * 파일 업로드 제한 용량 (10MB)
 */
export const FILE_SIZE_LIMIT = 10 * 1024 * 1024;

/**
 * 컬리/밀크런 픽업 타입
 */
export const PICKUP_SHIPPING_TYPES = {
  KURLY_PICKUP: 'KURLY_PICKUP',
  MILKRUN_PICKUP: 'MILKRUN_PICKUP',
} as const;

export type TypePickupShippingType = keyof typeof PICKUP_SHIPPING_TYPES;

/**
 * 화주사 유형
 */
export const OWNER_TYPES = {
  FBK: 'FBK',
  '3PL': '3PL',
  NFA: 'NFA',
} as const;

export type TypeOwnerType = (typeof OWNER_TYPES)[keyof typeof OWNER_TYPES] | null;

/**
 * 물류 유형
 */
export const LOGISTICS_TYPES = {
  FULFILLMENT: 'FULFILLMENT',
  DELIVERY: 'DELIVERY',
} as const;

export type TypeLogisticsType = keyof typeof LOGISTICS_TYPES;

/**
 * 날짜 포맷
 */
export const DATE_FORMAT = {
  DATE_TIME: 'YYYY.MM.DD HH:mm:ss',
  DATE: 'YYYY.MM.DD',
} as const;

/**
 * 공통 토스트 메시지
 */
export const TOAST_MESSAGE = {
  DEFAULT_ERROR: '작업 요청에 실패했습니다.\n다시 시도해주세요.',
  FILTER_ERROR: '필터 정보 호출 요청에 실패했습니다.\n페이지 새로고침을 시도해주세요.',
  DOWNLOADING: '다운로드 중..',
  DOWNLOAD_SUCCESS: '다운로드가 완료되었습니다.',
} as const;
